<template>
  <div class="gmf-clearfix gmf-gallery-thumbnails" @touchstart.passive="touchstart" @touchend.passive="touchend" @touchmove.passive="touchmove">
    <div class="gmf-gallery-thumbnail-anchor" ref="anchor" :style="{
      transform: 'translateX(' + (-xPan) + 'px)',
      transition: touchOrigin ? 'none' : null,
    }">
      <div
        v-for="(image, idx) in images"
        :key="image.url"
        ref="imageThumbnail"
        class="gmf-image-thumbnail-wrapper"
        :class="{'gmf-active': index === idx}"
        @click="selectImage(idx)"
      >
        <div class="gmf-image-thumbnail" :style="{'background-image': 'url(' + image.thumbnailUrl + ')'}" />
      </div>
    </div>
    <div class="gmf-gallery-thumbnail-nav gmf-gallery-thumbnail-nav-left" @click="left" :class="{'gmf-disabled': ! canGoLeft}"></div>
    <div class="gmf-gallery-thumbnail-nav gmf-gallery-thumbnail-nav-right" @click="right" :class="{'gmf-disabled': ! canGoRight}"></div>
  </div>
</template>

<script>
import elSize from '@/utils/mixins/elSize';

export default {
  props: ['images', 'index'],
  mixins: [elSize],
  data () {
    return {
      touchOrigin: null,
      panStart: 0,
      xPan: 0,
      isMounted: false,
    };
  },
  mounted () {
    this.isMounted = true; // hack to make refs semiöreactive
    this.$nextTick(this.ensureSelectedIsInView);
  },
  computed: {
    canGoLeft () {
      return this.xPan > 0;
    },
    canGoRight () {
      return this.xPan < this.overflowPixels;
    },
    overflowPixels () {
      if (! this.isMounted || ! this.$refs.anchor) {
        return 0;
      }

      const width = this.$refs.anchor.getBoundingClientRect().width;
      const contentWidth = this.imageWidth * this.images.length;
      const overflow = contentWidth - width;

      return overflow;
    },
    imageWidth () {
      let el = this.$refs.imageThumbnail;
      if (Array.isArray(el)) {
        el = el[0];
      }

      if (! this.isMounted || ! el) {
        return 0;
      }

      this.elSize.width; // Force reactivity


      const width = el.getBoundingClientRect().width;
      const margin = parseInt(window.getComputedStyle(el).marginRight);

      return width + margin + margin;
    },
    scrollDistance () {
      return ~~(this.elSize.width * 0.9);
    },
  },
  methods: {
    ensureSelectedIsInView () {
      const imageWidth = this.imageWidth;
      const imageX = this.index * imageWidth;
      const areaWidth = this.$refs.anchor.getBoundingClientRect().width;

      const margin = 20;

      if (imageX - margin < this.xPan) {
        this.xPan = imageX - margin;
      }

      if (imageX + imageWidth + margin - areaWidth > this.xPan) {
        this.xPan = imageX + imageWidth + margin - areaWidth;
      }
      this.capPan();
    },
    touchstart (ev) {
      this.touchOrigin = ev.touches[0];
      this.panStart = this.xPan;
    },
    touchend () {
      this.touchOrigin = null;
      this.capPan();
    },
    touchmove (ev) {
      if (! this.touchOrigin) {
        return;
      }
      this.xPan = this.panStart + this.touchOrigin.clientX - ev.touches[0].clientX;
    },
    capPan () {
      if (this.xPan > this.overflowPixels) {
        this.xPan = this.overflowPixels;
      }
      if (this.xPan < 0) {
        this.xPan = 0;
      }
    },
    left () {
      this.xPan -= this.scrollDistance;
      this.capPan();
    },
    right () {
      this.xPan += this.scrollDistance;
      this.capPan();
    },
    selectImage (idx) {
      this.$emit('update:index', idx);
    },
  },
  watch: {
    index () {
      this.ensureSelectedIsInView();
    },
    elSize () {
      this.capPan();
    },
  },
};
</script>
